import { render, staticRenderFns } from "./LinkMonetized.vue?vue&type=template&id=4f348c5a&"
import script from "./LinkMonetized.vue?vue&type=script&lang=js&"
export * from "./LinkMonetized.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports